import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ParametroConteudoInstalacaoProduto} from '../../../model/catalogo';

@Component({
    selector: 'item-param-conteudo-instalacao-produto',
    // templateUrl: './item-param-conteudo.component.html',
    // styleUrls: ['../../../../fta.css', '../../../itens-parametro.css', './item-param-conteudo.component.css']
    templateUrl: './item-param-conteudo-instalacao-produto.component.html',
    styleUrls: ['./item-param-conteudo-instalacao-produto.component.css']
})
export class ItemParametroConteudoInstalacaoProdutoComponent implements OnInit {

    @Input() index: number;
    @Input() parametro: ParametroConteudoInstalacaoProduto;
    @Input() novo: boolean;
    @Output() salvar = new EventEmitter<ParametroConteudoInstalacaoProduto>();
    @Output() excluir = new EventEmitter<ParametroConteudoInstalacaoProduto>();

    collapse: boolean = true;

    nrPosicao = new FormControl('', []);
    conteudo = new FormControl('', []);

    parametroForm: FormGroup = this.formBuilder.group({
        nrPosicao: this.nrPosicao,
        conteudo: this.conteudo
    });

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit() {
        if (this.parametro != null) {
            this.nrPosicao.setValue(this.parametro.nrPosicao);
            this.conteudo.setValue(this.parametro.conteudo);
        }
    }

    salvarParametro() {
        let parametro: ParametroConteudoInstalacaoProduto = this.parametroForm.value as ParametroConteudoInstalacaoProduto;

        if (this.parametro != null) {
            if (this.parametro.nrPosicao != parametro.nrPosicao) {
                this.excluir.emit(this.parametro);
            }
        }

        this.salvar.emit(parametro);

        if (this.novo) {
            this.parametroForm.reset();
            this.parametro = null;
        }

        this.editarParametro();
    }

    editarParametro() {
        if (this.collapse) {
            this.collapse = false;
        } else {
            this.collapse = true;
        }
    }

    excluirParametro() {
        this.excluir.emit(this.parametro);
    }

    cancelar() {
        if (this.novo) {
            this.parametroForm.reset();
        }
        this.editarParametro();
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/item-param-conteudo-instalacao-produto/item-param-conteudo-instalacao-produto.component.ts